import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { env } from "../env";

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const businessSlug = localStorage.getItem("businessSlug");
  const accessToken = localStorage.getItem("accessToken");
  const branchId = localStorage.getItem("branchId");
  const email = localStorage.getItem("email");
  const branchPOSId = localStorage.getItem("branchPOSId");
  const hasAllCredentials = accessToken && branchId && email && branchPOSId;
  const hasAccessTokenAndEmail = accessToken && email && !branchId;
  const hasPartialCredentials =
    accessToken && branchId && email && !branchPOSId;

  const handleRedirect = () => {
    if (currentPath.includes("/*")) {
      window.location.href = env.REACT_APP_ALLDERCAFE;
      return;
    }
    if (hasAccessTokenAndEmail && !branchId) {
      navigate(`/${businessSlug}/branch-selection`);
    } else if (hasPartialCredentials) {
      navigate(`/${businessSlug}/pos-setting`);
    } else if (hasAllCredentials) {
      navigate(`/${businessSlug}`);
    } else if (accessToken) {
      navigate(`/${businessSlug}/login`);
    } else {
      window.location.href = env.REACT_APP_ALLDERCAFE;
    }
  };

  useEffect(() => {}, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light">
      <div className="text-center py-5 px-28 bg-white rounded shadow">
        <h1 className="display-1 fw-bold text-primary mb-4">404</h1>
        <h2 className="h3 mb-4">Page Not Found</h2>
        <p className="text-muted mb-4">ขออภัย ไม่พบหน้าที่คุณต้องการ</p>
        <button onClick={handleRedirect} className="btn btn-primary px-4 py-2">
          {hasAllCredentials
            ? "กลับสู่หน้าแรก"
            : hasAccessTokenAndEmail || hasPartialCredentials
            ? "ไปยังหน้าตั้งค่า"
            : "กลับสู่หน้าแรก"}
        </button>
      </div>
    </div>
  );
}
